import React from 'react';
import NavbarTop from '../components/NavbarTop';
import NavbarBottom from '../components/NavbarBottom';
import DevicesList from '../components/DevicesList';

const Devices = () => {
  return (
    <div>
      <NavbarTop />
      <DevicesList />
      <NavbarBottom />
    </div>
  );
};

export default Devices;
